
































import { currencies } from '@/constants';
import FieldBase from '@/components/field/Base.vue';

export default {
  props: {
    currencies: Array,
    value: {
      type: Object,
      default: () => ({
        price_retail: {},
        price_wholesale: {},
      }),
    },
  },
  data: () => ({
    fieldParams: {
      attributes: {
        placeholder: '0.00',
        type: 'number',
      },
    },
  }),
  methods: {
    getCurrency: (code: string) => (currencies as any)[code],
  },
  components: {
    FieldBase,
  },
} as IView;
